<template>
  <div class="book-scene">
    <router-link to="/project"><div class="Flip"></div></router-link>
    
    <div class="book">
      <div id="pages" class="pages">
        <!-- Front Cover -->
        <div class="page front-cover">
          <div class="book-cover">
            <div class="cover-ornament top"></div>
            <div class="deer-logo">
              <img src="../../public/Ail.png" alt="Deer Logo">
            </div>
            <h1 class="book-title">REED</h1>
            <div class="subtitle-cover">Portfolio</div>
            <div class="cover-ornament bottom"></div>
            <div class="leather-texture"></div>
          </div>
        </div>
        
        <!-- Inner pages -->
        <div class="page"><img class="imgD" src="../assets/images/1.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/2.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/3.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/4.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/5.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/24.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/7.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/8.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/9.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/10.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/11.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/12.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/13.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/14.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/15.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/16.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/Pr18.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/Pr19.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/Pr20.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/Pr21.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/Pr22.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/Pr23.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/Pr24.png" alt=""></div>
        <div class="page"><img class="imgD" src="../assets/images/Pr25.png" alt=""></div>
        
        <!-- Back Cover -->
        <div class="page back-cover">
          <div class="book-cover back">
            <div class="back-pattern"></div>
            <div class="back-text">fin</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="javascript">
export default {
  data(){
    return{
      pages:[],
    }
  },
  created(){
    
  },
  mounted(){
    this.pages = document.getElementsByClassName('page');
    console.log(this.pages)
    for(var i = 0; i < this.pages.length; i++)
    {
      var page = this.pages[i];
      if (i % 2 === 0)
      {
        page.style.zIndex = (this.pages.length - i);
      }
    }
    console.log("out");
    this.doit();
  },

  methods:{
    doit(){
      console.log("hey");
      for(var i = 0; i < this.pages.length; i++)
      {
        var page = this.pages[i];
        page.pageNum = i + 1;
        page.onclick=function()
        {
          if (this.pageNum % 2 === 0)
          {
            this.classList.remove('flipped');
            this.previousElementSibling.classList.remove('flipped');
          }
          else
          {
            this.classList.add('flipped');
            this.nextElementSibling.classList.add('flipped');
          }
        }
      }
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: "Quarrel";
  src: url("../assets/LoversQuarrel-Regular.ttf");
}

/* Book Scene */
.book-scene {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

/* Leather Book Cover */
.front-cover .book-cover,
.back-cover .book-cover {
  width: 100%;
  height: 100%;
  background: 
    linear-gradient(135deg, 
      #5d4e37 0%,
      #3d2f23 25%,
      #5d4e37 50%,
      #3d2f23 75%,
      #5d4e37 100%);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* Leather Texture */
.leather-texture {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0,0,0,.03) 2px, rgba(0,0,0,.03) 4px),
    repeating-linear-gradient(90deg, transparent, transparent 2px, rgba(0,0,0,.03) 2px, rgba(0,0,0,.03) 4px);
  opacity: 0.4;
  pointer-events: none;
}

/* Gold Embossed Border */
.front-cover .book-cover::before {
  content: '';
  position: absolute;
  top: 30px;
  left: 30px;
  right: 30px;
  bottom: 30px;
  border: 3px solid #d4af37;
  box-shadow: 
    0 0 0 1px #8b7355,
    inset 0 0 0 1px #8b7355,
    0 2px 8px rgba(212, 175, 55, 0.5),
    inset 0 -2px 8px rgba(0, 0, 0, 0.3);
  pointer-events: none;
  z-index: 1;
}

/* Deer Logo */
.deer-logo {
  width: 160px;
  height: 160px;
  margin-bottom: 25px;
  position: relative;
  z-index: 2;
  filter: 
    drop-shadow(0 6px 12px rgba(0, 0, 0, 0.7))
    drop-shadow(0 0 25px rgba(212, 175, 55, 0.4));
}

.deer-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Book Title */
.book-title {
  font-family: 'Garamond', 'Times New Roman', serif;
  font-size: 82px;
  font-weight: 700;
  letter-spacing: 18px;
  color: #d4af37;
  text-shadow: 
    0 3px 6px rgba(0, 0, 0, 0.9),
    0 0 20px rgba(212, 175, 55, 0.4),
    2px 2px 0 #8b7355,
    3px 3px 0 #5d4e37,
    -1px -1px 0 #ffd700;
  margin: 15px 0;
  position: relative;
  z-index: 2;
  text-transform: uppercase;
  font-style: normal;
  text-rendering: optimizeLegibility;
}

/* Subtitle */
.subtitle-cover {
  font-family: 'Garamond', 'Times New Roman', serif;
  font-size: 32px;
  color: #d4af37;
  letter-spacing: 10px;
  text-transform: uppercase;
  margin-top: 15px;
  font-weight: 400;
  font-style: italic;
  text-shadow: 
    0 2px 4px rgba(0, 0, 0, 0.8),
    0 0 15px rgba(212, 175, 55, 0.3),
    1px 1px 0 #8b7355;
  position: relative;
  z-index: 2;
}

/* Decorative Ornaments */
.cover-ornament {
  width: 280px;
  height: 2px;
  position: relative;
  z-index: 2;
  background: linear-gradient(90deg, transparent, #d4af37 20%, #d4af37 80%, transparent);
  box-shadow: 
    0 0 15px rgba(212, 175, 55, 0.6),
    0 1px 3px rgba(0, 0, 0, 0.8);
}

.cover-ornament::before,
.cover-ornament::after {
  content: '';
  position: absolute;
  width: 8px;
  height: 8px;
  background: #d4af37;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%);
  box-shadow: 0 0 10px rgba(212, 175, 55, 0.8);
}

.cover-ornament::before {
  left: 15%;
}

.cover-ornament::after {
  right: 15%;
}

.cover-ornament.top {
  margin-bottom: 35px;
}

.cover-ornament.bottom {
  margin-top: 35px;
}

/* Back Cover */
.back-cover .book-cover {
  background: 
    linear-gradient(135deg, 
      #4a3c2e 0%,
      #2d2419 50%,
      #4a3c2e 100%);
}

.back-pattern {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: 
    repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(0,0,0,.05) 10px, rgba(0,0,0,.05) 20px);
  opacity: 0.3;
}

.back-text {
  font-family: Georgia, serif;
  font-size: 42px;
  font-style: italic;
  color: #8b7355;
  letter-spacing: 8px;
  position: relative;
  z-index: 2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.6);
}

/* Navigation Button - positioned at absolute top-left corner */
div .Flip {
  position: fixed;
  background-image: url("../assets/layerFlip.png");
  background-repeat: no-repeat;
  background-size: contain;
  z-index: 200;
  width: 70px;
  height: 70px;
  left: 0;
  top: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  touch-action: manipulation;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.5));
}

div .Flip:hover {
  filter: brightness(1.2) drop-shadow(0 4px 12px rgba(212, 175, 55, 0.4));
  transform: scale(1.1);
}

/* Page Images */
.imgD {
  margin-top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Book Structure */
.book {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  perspective: 250vw;
}

.book .pages {
  width: 98vw;
  max-width: 1600px;
  height: 65vh;
  max-height: 750px;
  position: relative;
  transform-style: preserve-3d;
  backface-visibility: hidden;
}

.book .page {
  float: none;
  clear: none;
  margin: 0;
  position: absolute;
  top: 0;
  width: 49vw;
  max-width: 800px;
  height: 65vh;
  max-height: 750px;
  transform-origin: 0 0;
  transition: transform 1.8s cubic-bezier(0.645, 0.045, 0.355, 1);
  backface-visibility: hidden;
  transform-style: preserve-3d;
  cursor: pointer;
  user-select: none;
  background-color: #f4f1ea;
  background-image: 
    linear-gradient(90deg, rgba(139, 115, 85, 0.05) 0%, transparent 5%),
    linear-gradient(to bottom, #f8f6f0 0%, #f4f1ea 100%);
}

/* Page Paper Texture */
.book .page:not(.front-cover):not(.back-cover)::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139,115,85,.02) 2px, rgba(139,115,85,.02) 4px);
  pointer-events: none;
  opacity: 0.5;
}

/* Page Shadows and Effects */
.book .page:before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0);
  transition: background 0.7s;
  z-index: 10;
}

/* Right Pages (Odd) */
.book .page:nth-child(odd) {
  pointer-events: all;
  transform: rotateY(0deg);
  right: 0;
  border-radius: 0 2px 2px 0;
  background-image: 
    linear-gradient(to left, rgba(139, 115, 85, 0.15) 0%, transparent 10%),
    linear-gradient(to bottom, #f8f6f0 0%, #f4f1ea 100%);
}

.book .page:nth-child(odd):hover {
  transform: rotateY(-10deg);
}

.book .page:nth-child(odd):hover:before {
  background: rgba(0, 0, 0, 0.02);
}

/* Left Pages (Even) */
.book .page:nth-child(even) {
  pointer-events: none;
  transform: rotateY(180deg);
  transform-origin: 100% 0;
  left: 0;
  border-radius: 2px 0 0 2px;
  background-image: 
    linear-gradient(to right, rgba(139, 115, 85, 0.15) 0%, transparent 10%),
    linear-gradient(to bottom, #f8f6f0 0%, #f4f1ea 100%);
}

.book .page:nth-child(even):before {
  background: rgba(0, 0, 0, 0.1);
}

/* Flipped Pages */
.book .page.flipped:nth-child(odd) {
  pointer-events: none;
  transform: rotateY(-180deg);
}

.book .page.flipped:nth-child(odd):before {
  background: rgba(0, 0, 0, 0.1);
}

.book .page.flipped:nth-child(even) {
  pointer-events: all;
  transform: rotateY(0deg);
}

.book .page.flipped:nth-child(even):hover {
  transform: rotateY(10deg);
}

.book .page.flipped:nth-child(even):hover:before {
  background: rgba(0, 0, 0, 0.02);
}

/* Page Counter */
.page-counter {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 10px 20px;
  border-radius: 25px;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 18px;
  z-index: 1000;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

/* Responsive Adjustments */
@media (max-width: 1024px) {
  .deer-logo {
    width: 140px;
    height: 140px;
  }
  
  .book-title {
    font-size: 56px;
    letter-spacing: 10px;
  }
  
  .subtitle-cover {
    font-size: 22px;
  }
  
  div .Flip {
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 768px) {
  .deer-logo {
    width: 100px;
    height: 100px;
  }
  
  .book-title {
    font-size: 42px;
    letter-spacing: 8px;
  }
  
  .subtitle-cover {
    font-size: 18px;
    letter-spacing: 4px;
  }
  
  .front-cover .book-cover::before {
    top: 20px;
    left: 20px;
    right: 20px;
    bottom: 20px;
    border-width: 2px;
  }
  
  .cover-ornament {
    width: 150px;
    height: 30px;
  }
  
  div .Flip {
    width: 50px;
    height: 50px;
  }
  
  .page-counter {
    font-size: 14px;
    padding: 10px 20px;
    bottom: 20px;
  }
  
  .book .page:nth-child(odd):hover,
  .book .page.flipped:nth-child(even):hover {
    transform: rotateY(0deg);
  }
}

@media (max-width: 480px) {
  .deer-logo {
    width: 80px;
    height: 80px;
  }
  
  .book-title {
    font-size: 36px;
    letter-spacing: 6px;
  }
  
  .subtitle-cover {
    font-size: 16px;
    letter-spacing: 3px;
  }
  
  .front-cover .book-cover::before {
    top: 15px;
    left: 15px;
    right: 15px;
    bottom: 15px;
  }
  
  .cover-ornament {
    width: 120px;
    height: 25px;
  }
  
  .cover-ornament.top {
    margin-bottom: 20px;
  }
  
  .cover-ornament.bottom {
    margin-top: 20px;
  }
  
  div .Flip {
    width: 45px;
    height: 45px;
  }
  
  .back-text {
    font-size: 32px;
  }
}
</style>
